import { render, staticRenderFns } from "./ReportTeam.vue?vue&type=template&id=10819ffb&"
import script from "./ReportTeam.vue?vue&type=script&lang=js&"
export * from "./ReportTeam.vue?vue&type=script&lang=js&"
import style0 from "./ReportTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports